import { BaseDto } from "./base.dto";
import { StockDto } from "./stock.dto";

export class StockNutritionDto extends BaseDto {
    saturatedFat: number;
    transFat: number;
    cholesterol: number;
    carbohydrate:number;
    energy:number;
    sodium: number;
    dietaryFiber: number;
    sugars: number;
    calories: number;
    protein: number;
    stock: StockDto;
  }